import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    droga: [],
  },

  getters: {
    getDroga: (state) => state.droga,

    getListaDrogas: (state) => {
      const listaDrogas = [];

      state.droga.forEach((droga) => {
        listaDrogas.push({
          fk_idCatDroga: droga.id,
          droga: droga.title,
          motivo: '',
          edadConsumo: 0,
          cantidadConsumo: '',
          ultimoConsumo: null,
          consumoActual: false,
          detalleConsumo: '',
          combinacionConAlcohol: false,
          consumoCompania: false,
          conocimientoDrogaFisica: true,
        });
      });

      return listaDrogas;
    },
  },

  mutations: {
    SET_DROGA(state, droga) {
      state.droga = droga;
    },
  },

  actions: {
    async fetchDroga({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catDroga')
        .then((response) => {
          commit('SET_DROGA', response.data.data);
        });
    },
  },
};
